import React, { useState } from 'react';
import PinInput from './PinInput';

function PlaylistForm({ initialData, onSubmit, isLoading, submitLabel = 'Save' }) {
  const [name, setName] = useState(initialData?.name || '');
  const [url, setUrl] = useState(initialData?.m3uUrl || initialData?.xtreamHost || '');

  const [showPinSection, setShowPinSection] = useState(initialData?.hasPin || false);
  const [currentPin, setCurrentPin] = useState('');
  const [newPin, setNewPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [pinAction, setPinAction] = useState(initialData?.hasPin ? 'keep' : 'none');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name.trim()) {
      alert('Please enter a playlist name');
      return;
    }

    if (!url.trim()) {
      alert('Please enter a playlist URL');
      return;
    }

    const data = {
      name: name.trim(),
      url: url.trim()
    };

    // Handle PIN
    if (pinAction === 'set' || pinAction === 'change') {
      if (newPin.length !== 6) {
        alert('PIN must be exactly 6 digits');
        return;
      }
      if (newPin !== confirmPin) {
        alert('PINs do not match');
        return;
      }
      data.pin = newPin;
      if (pinAction === 'change') {
        data.currentPin = currentPin;
      }
    } else if (pinAction === 'remove') {
      data.pin = null;
      data.currentPin = currentPin;
    }

    onSubmit(data);
  };

  const renderPinSection = () => {
    if (!showPinSection) {
      return (
        <button
          type="button"
          className="pin-toggle-btn"
          onClick={() => setShowPinSection(true)}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          Add PIN Protection
        </button>
      );
    }

    // Existing PIN
    if (initialData?.hasPin) {
      return (
        <div className="pin-options">
          <div className="form-group">
            <label>PIN Protection</label>
            <select
              value={pinAction}
              onChange={(e) => {
                setPinAction(e.target.value);
                setCurrentPin('');
                setNewPin('');
                setConfirmPin('');
              }}
            >
              <option value="keep">Keep current PIN</option>
              <option value="change">Change PIN</option>
              <option value="remove">Remove PIN</option>
            </select>
          </div>

          {(pinAction === 'change' || pinAction === 'remove') && (
            <PinInput
              value={currentPin}
              onChange={setCurrentPin}
              label="Enter current PIN"
              autoFocus
            />
          )}

          {pinAction === 'change' && (
            <>
              <PinInput
                value={newPin}
                onChange={setNewPin}
                label="Enter new PIN"
              />
              <PinInput
                value={confirmPin}
                onChange={setConfirmPin}
                label="Confirm new PIN"
              />
            </>
          )}
        </div>
      );
    }

    // New PIN
    return (
      <div className="pin-options">
        <div className="form-group">
          <label>PIN Protection</label>
          <select
            value={pinAction}
            onChange={(e) => {
              setPinAction(e.target.value);
              setNewPin('');
              setConfirmPin('');
            }}
          >
            <option value="none">No PIN</option>
            <option value="set">Set PIN</option>
          </select>
        </div>

        {pinAction === 'set' && (
          <>
            <PinInput
              value={newPin}
              onChange={setNewPin}
              label="Enter 6-digit PIN"
              autoFocus
            />
            <PinInput
              value={confirmPin}
              onChange={setConfirmPin}
              label="Confirm PIN"
            />
          </>
        )}
      </div>
    );
  };

  return (
    <form className="playlist-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label>
          Playlist Name <span className="required">*</span>
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="My Playlist"
          required
        />
      </div>

      <div className="form-group">
        <label>
          Playlist URL <span className="required">*</span>
        </label>
        <input
          type="url"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="http://example.com/playlist.m3u"
          required
        />
      </div>

      <div className="pin-section">
        {renderPinSection()}
      </div>

      <button
        type="submit"
        className="btn btn-primary btn-full"
        disabled={isLoading}
      >
        {isLoading ? 'Saving...' : submitLabel}
      </button>
    </form>
  );
}

export default PlaylistForm;
